import { Inject, Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { map, Observable } from 'rxjs';
import { ContextData } from './context-files-service.types';
import { PagedResponse } from '@bioconnect-ui/shared-service';

export interface ContextFilesConfig {
  restServer: string;
}

@Injectable({
  providedIn: 'root',
})
export class ContextFilesService {

  constructor(
    private httpClient: HttpClient,
    @Inject('contextFilesConfig') private env: ContextFilesConfig,
  ) {}

  private restServer = this.env.restServer;

  getContextFiles(contentType: string, objectId: number): Observable<ContextData[]> {
    return this.httpClient.get<PagedResponse>(
      `${this.restServer}/metadata_repository/context_data/?content_type=${contentType}&object_id=${objectId}&page_size=1000`
    ).pipe(map((result) => <ContextData[]>result.results));
  }

  addContextFile(contextData: ContextData, contentType: string, objectId: number): Observable<ContextData> {
    return this.httpClient.post<ContextData>(
      `${this.restServer}/metadata_repository/context_data/`,
      { ...contextData, content_type: contentType, object_id: objectId }
    );
  }

  updateContextFile(contextData: ContextData): Observable<ContextData> {
    return this.httpClient.patch<ContextData>(
      `${this.restServer}/metadata_repository/context_data/${contextData.id}/`,
      contextData
    );
  }

  deleteContextFile(id: number): Observable<void> {
    return this.httpClient.delete<void>(
      `${this.restServer}/metadata_repository/context_data/${id}/`
    );
  }
}
